import Vue from "vue";
import {
  Toast,
  Dialog,
  DropdownMenu,
  DropdownItem,
  List,
  Rate,
  ImagePreview,
  Image,
  Area,
  Popup,
  Picker,
  Radio,
  RadioGroup,
  Icon,
  Search,
  Tab,
  Tabs,
  NavBar,
  Swipe,
  SwipeItem,
  Uploader,
  Field,
  Step,
  Steps,
  Loading,
  DatetimePicker,
  Overlay,
  SwipeCell,
  Cell,
  Button,
  Stepper,
  PasswordInput,
  NoticeBar,
  Grid,
  GridItem,
  Collapse,
  CollapseItem,
  Skeleton,
  Form,
  Tabbar,
  TabbarItem,
  Checkbox,
  Empty,
  Divider,
  ActionSheet,
  Switch,
  PullRefresh,
  Sticky
} from "vant";

Vue.use(ActionSheet);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(List);
Vue.use(Rate);
Vue.use(ImagePreview);
Vue.use(Image);
Vue.use(Area);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Icon);
Vue.use(Search);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(NavBar);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Uploader);
Vue.use(Field);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Loading);
Vue.use(DatetimePicker);
Vue.use(Overlay);
Vue.use(SwipeCell);
Vue.use(Cell);
Vue.use(Button);
Vue.use(Stepper);
Vue.use(PasswordInput);
Vue.use(NoticeBar);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Skeleton);
Vue.use(Form);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Checkbox);
Vue.use(Empty);
Vue.use(Divider);
Vue.use(Switch);
Vue.use(PullRefresh);
Vue.use(Sticky);
Vue.prototype.$toast = Toast;
Vue.prototype.$dialog = Dialog;
Vue.prototype.$imagePreview = ImagePreview;



// WEBPACK FOOTER //
// ./src/vant-ui/index.js